import { ACTION_TYPES } from './actionTypes'

export const popupAction = (payload) => ({
	type: ACTION_TYPES.POPUP,
	payload,
})
